function ETrackerPluginEvent(etracker) {
  return function sendEvent(event_id) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!event_id) {
      return console.warn('[ETracker plugin-event]', 'event_id不能为空');
    }
    etracker.log('event', {
      p1: event_id,
      p2: data.et || 'OTHER',
      c1: data.c1,
      c2: data.c2,
      c3: data.c3,
      c4: data.c4,
      c5: data.c5,
      c6: data.c6
    });
  };
}

export { ETrackerPluginEvent as default };
